var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-box--calculator"},[_c('div',{staticClass:"c-calculator"},[_c('div',{staticClass:"c-calculator__container"},[_c('quoter')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }